<template>
  <div class="complete">
    <div class="cont">
      <p class="title">We have received your message and will contact you as soon as possible!</p>

      <img src="/pc/static/img/poker/done.png" class="done">

      <div class="btns center submit" @click="toHome()">
        <span>BACK TO HOME PAGE</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {}
  },
  methods: {
    toHome () {
      this.$router.push({ name: 'poker-home-contact' })
    }
  }
}
</script>

<style lang="scss" scoped>
.complete {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  .cont {
    width: 700px;
    .title {
      color: #54595f;
      font-size: 26px;
      line-height: 36px;
      margin: 100px auto 80px auto;
    }
    .done {
      display: inherit;
      margin: 0 auto;
    }
    .btns {
      background-image: url("/pc/static/img/poker/btn.png");
      background-size: cover;
      background-position: center;
      margin: 80px auto;
      width: 288px;
      height: 54px;
      cursor: pointer;
      margin-bottom: 26px;
      span {
        font-size: 20px;
        color: #ffffff;
        line-height: 54px;
      }
    }
  }
}
</style>
